export default __webpack_public_path__ + "static/media/liveFeedProject.28e0129d.png";